import { render, staticRenderFns } from "./shengma.vue?vue&type=template&id=e34ba70a&scoped=true&"
import script from "./shengma.vue?vue&type=script&lang=js&"
export * from "./shengma.vue?vue&type=script&lang=js&"
import style0 from "./shengma.vue?vue&type=style&index=0&id=e34ba70a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34ba70a",
  null
  
)

export default component.exports